


// const StatsSection = ({ data }) => {
//   if (!data) return null;

//   const items = data.fifthsub || [];
//   if (!items.length) return null;

//   const styles = `
//     .stats-section {
//       width: 100%;
//       background: #FBFBFB;
//       padding: 32px 40px;
//       box-sizing: border-box;
//     }
//     .stats-grid {
//       display: grid;
//       grid-template-columns: repeat(${items.length}, minmax(0, 1fr));
//       gap: 16px;
//       width: 100%;
//     }
//     .stats-card {
//       background: #EEF2F7;
//       border-radius: 8px;
//       padding: 28px 16px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       gap: 10px;
//     }
//     .stats-number {
//       font-family: Inter, sans-serif;
//       font-weight: 600;
//       font-size: 36px;
//       line-height: 34.55px;
//       letter-spacing: 0;
//       text-align: center;
//       color: #001064;
//     }
//     .stats-desc {
//       font-family: Inter, sans-serif;
//       font-weight: 600;
//       font-size: 16px;
//       line-height: 15.07px;
//       letter-spacing: 0;
//       text-align: center;
//       color: #3A3A3A;
//     }

//     /* ── Tablet large (1101–1279px) ── */
//     @media (max-width: 1279px) and (min-width: 1101px) {
//       .stats-section { padding: 28px 32px; }
//       .stats-number { font-size: 30px; }
//       .stats-desc { font-size: 15px; }
//     }

//     /* ── Tablet (768–1100px) ── */
//     @media (max-width: 1100px) and (min-width: 768px) {
//       .stats-section { padding: 24px 24px; }
//       .stats-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
//       .stats-card { padding: 22px 12px; }
//       .stats-number { font-size: 28px; line-height: 1.2; }
//       .stats-desc { font-size: 14px; line-height: 1.3; }
//     }

//     /* ── Mobile (max 767px) ── */
//     @media (max-width: 767px) {
//       .stats-section { padding: 20px 14px; }
//       .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
//       .stats-card { padding: 20px 10px; gap: 8px; }
//       .stats-number { font-size: 26px; line-height: 1.2; }
//       .stats-desc { font-size: 13px; line-height: 1.3; }
//     }

//     /* ── Small mobile (max 480px) ── */
//     @media (max-width: 480px) {
//       .stats-section { padding: 16px 10px; }
//       .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
//       .stats-card { padding: 16px 8px; gap: 6px; border-radius: 6px; }
//       .stats-number { font-size: 22px; }
//       .stats-desc { font-size: 12px; }
//     }
//   `;

//   return (
//     <>
//       <style>{styles}</style>
//       <section className="stats-section">
//         <div className="stats-grid">
//           {items.map((item, index) => (
//             <div key={item.id ?? index} className="stats-card">
//               <span className="stats-number">{item.number}</span>
//               <span className="stats-desc">{item.description}</span>
//             </div>
//           ))}
//         </div>
//       </section>
//     </>
//   );
// };

// export default StatsSection;


import { useState, useEffect } from "react";

const StatsSection = ({ data }) => {
  const [apiStats, setApiStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASEURL_STATS;
        const res = await fetch(`${baseUrl}/platform/stats`);
        const json = await res.json();
        setApiStats(json);
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      }
    };
    fetchStats();
  }, []);

  if (!data) return null;

  const items = (data.fifthsub || []).slice(0, 5); // show only the first 5 — extra (duplicate) CMS entries are ignored
  if (!items.length) return null;

  // Map API field keys to CMS description keywords (case-insensitive match)
  const apiKeyMap = [
    { keywords: ["eclinic", "clinic"],         apiKey: "total_eclinics" },
    { keywords: ["village", "town"],            apiKey: null },             // not in API
    { keywords: ["patient"],                    apiKey: "happy_patients" },
    { keywords: ["special"],                    apiKey: "total_specialities" },
    { keywords: ["hospital", "diagnostic", "service", "provider"], apiKey: "total_hospitals_and_diagnostics" },
  ];

  const resolveNumber = (item) => {
    if (!apiStats) return item.number;

    const desc = (item.description || "").toLowerCase();
    const match = apiKeyMap.find(({ keywords }) =>
      keywords.some((kw) => desc.includes(kw))
    );

    if (match && match.apiKey && apiStats[match.apiKey] != null) {
      const val = apiStats[match.apiKey];
      // Format: 1000+ → "1k", keep original suffix style if CMS used it
      if (typeof item.number === "string" && item.number.toLowerCase().includes("k")) {
        return val >= 1000 ? `${Math.round(val / 1000)}k` : val;
      }
      return val.toLocaleString();
    }

    // Fallback to CMS number
    return item.number;
  };

  const styles = `
    .stats-section {
      width: 100%;
      background: #ffffff;
      padding: 40px max(60px, calc(50% - 660px));
      box-sizing: border-box;
    }
    .stats-grid {
      display: grid;
      grid-template-columns: repeat(${items.length}, minmax(0, 1fr));
      gap: 20px;
      width: 100%;
    }
    .stats-card {
      background: #ffffff;
      border: 1px solid #DFF1FB;
      border-radius: 12px;
      box-shadow: 0px 0px 15px 0px #80DAF1;
      padding: 32px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
    .stats-number {
      font-family: Inter, sans-serif;
      font-weight: 700;
      font-size: 36px;
      line-height: 1.1;
      letter-spacing: 0;
      text-align: center;
      color: var(--color-brand-primary);
    }
    .stats-desc {
      font-family: Inter, sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 1.3;
      letter-spacing: 0;
      text-align: center;
      color: var(--color-text-subheading);
    }

    @media (max-width: 1279px) and (min-width: 1101px) {
      .stats-section { padding: 36px 40px; }
      .stats-number { font-size: 30px; }
      .stats-desc { font-size: 15px; }
    }
    @media (max-width: 1100px) and (min-width: 768px) {
      .stats-section { padding: 28px 28px; }
      .stats-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
      .stats-card { padding: 22px 12px; }
      .stats-number { font-size: 28px; line-height: 1.2; }
      .stats-desc { font-size: 14px; line-height: 1.3; }
    }
    @media (max-width: 767px) {
      .stats-section { padding: 24px 14px; }
      .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
      .stats-card { padding: 20px 10px; gap: 8px; }
      .stats-number { font-size: 26px; line-height: 1.2; }
      .stats-desc { font-size: 13px; line-height: 1.3; }
    }
    @media (max-width: 480px) {
      .stats-section { padding: 16px 10px; }
      .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
      .stats-card { padding: 16px 8px; gap: 6px; border-radius: 10px; }
      .stats-number { font-size: 22px; }
      .stats-desc { font-size: 12px; }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <section className="stats-section">
        <div className="stats-grid">
          {items.map((item, index) => (
            <div key={item.id ?? index} className="stats-card">
              <span className="stats-number">{resolveNumber(item)}</span>
              <span className="stats-desc">{item.description}</span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default StatsSection;